import axios from "axios";
import { SellTradeFormType } from "../types/SellTradeForm.types";

export const offerApis = {
  apply: (requestData: SellTradeFormType) => {
    return axios
      .post(`/Offers`, requestData, {
        headers: {
          "Access-Control-Allow-Origin": true,
          "Content-type": "application/json",
        },
      })
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  },
};
